import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const OptionWithTooltip = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "right",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.dimension-editor-dropdown.config.disabledOption"
      }),
      disabled: !option.disabled,
      children: children
    })
  }));
};
export default OptionWithTooltip;